import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '../Services/users.service';
import { HomeComponentServicesService } from '../Services/home-component-services.service';
import { CmsFooterContactsProperties } from '../Models/CmsFooterContactsProperties';
import { CmsFooterSitemapProperties } from '../Models/CmsFooterContactsProperties';
import { CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLoginHeaderProperties, CmsLogoProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginDealsProperties } from '../Models/CmsLoginDealsProperties';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { LoginUserProperties } from '../Models/UsersProperties';
import { GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
/*import { OTPTwilioSendProperties, OTPTwilioVerifyReqProperties } from '../Models/OTPTwilioProperties';*/
import { FormGroup, FormControl, Validators, AbstractControl, FormBuilder } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { SwiperOptions } from 'swiper';
import * as $ from "jquery";
import { CMSService } from '../Services/cms.service';
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { AuthService } from '../Services/auth.service';
import { AgencyService } from '../Services/Agency.service';
declare const scrollUp: any;
declare const swiperPortfolio: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  //public phoneForm: FormGroup;
  //phoneNumber: string = "";

  constructor(private authservice: AuthService, public cmsService: CMSService, private router: Router, public homeComponentServicesService: HomeComponentServicesService,
    private Location: LocationStrategy, private activatedRoute: ActivatedRoute, private agencyService: AgencyService
  ) {
  }
  contentHome: boolean = false;
  allData$: GetAllCmsLoginProperties;
  navigation: CmsLoginHeaderProperties[] = [];
  loginLanding: CmsLoginMainContentProperties[] = [];
  deals: CmsLoginDealsProperties[] = [];
  footerContacts: CmsFooterContactsProperties[] = [];
  footerSitemap: CmsFooterSitemapProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  homeLogo = new CmsLogoProperties();
  logo = '';
  spin = faSpinner;
  footerlogo = '';
  loginCred = new LoginUserProperties();
  otpPrompt: string = "We just have sent an OTP at your registered email. Please, enter that code below and Verify to access your account.";
  wrongOTPPrompt: string = "Invalid OTP, Please try again..!";
  varificationPrompt: string;
  //loginEmailVerifyObj = new LoginUserProperties();
  /*twilioObj = new OTPTwilioSendProperties();*/
  /* twilioVerifyObj = new OTPTwilioVerifyReqProperties();*/
  Sid: string;
  emailTo: string;
  otpToSend: string;
  separateDialCode = true;
  valid = true;

  //loginCred = new LoginUserProperties();

  actives: string = "";
  checkv: string = "";
  //SearchCountryField = SearchCountryField;
  //TooltipLabel = TooltipLabel;
  //CountryISO = CountryISO;
  //phoneForm = new FormGroup({
  //  phone: new FormControl('', [Validators.required])
  //});

  //galleryDataSource = [

  //  { path: this.dealsData },
  //  { name: this.dealsData },
  //  //{ path: "assets/img/slideritem1.jpg", name: "Save Up to 10% on flights to select destination with AIR ARABIA" },
  //  //{ path: "assets/img/slideritem2.jpg", name: "Save Up to 10% on flights to select destination with AIR ARABIA" },
  //];
  config: SwiperOptions = {
    slidesPerView: 3,
    cssMode: true,
    loop: true,
    autoplay: {
      delay: 3000
    },
    spaceBetween: 22,
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
      },
      // when window width is >= 640px
      720: {
        slidesPerView: 2,
        spaceBetween: 28
      },

      1020: {
        slidesPerView: 3,
        spaceBetween: 22
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 30
      }

    }
  };
  LoginDataList: any[];
  private redirectUrl: string;
  filtersLoaded: Promise<boolean>;
  ngOnInit() {

    //localStorage.clear();
    let userid = Number(localStorage.getItem("UserId"));
    let agencyId = localStorage.getItem("AgencyId");
    if (userid > 0 && userid != null && userid != undefined && agencyId != null && agencyId != undefined && agencyId != "") {

      let timelogin = (localStorage.getItem("TimeOfLogin"));
      let timeloginofdiff = JSON.parse(timelogin);
      //console.log("timeloginofdiff", timeloginofdiff);
      let datetimefuture = new Date(timeloginofdiff);
      //console.log("datetimepast", datetimefuture);
      let datenow = new Date();
      //console.log("datenow", datenow);
      if (datenow < datetimefuture) {

        this.router.navigateByUrl('/flightSearch');
      }
      else {

        window.localStorage.setItem('logout-event', Math.random().toString());
        this.authservice.logOut();
        this.router.navigateByUrl('/home');
      }
    }
    else {
      this.getAllData();
      history.pushState(null, null, window.location.href);

      this.Location.onPopState(() => {

        history.pushState(null, null, window.location.href);

      });
    }


  }

  check() {
    var st = document.getElementById('password') as HTMLInputElement;
    var stu = document.getElementById('confirm_password') as HTMLInputElement;
    if (st.value == stu.value) {
      document.getElementById('message').style.color = 'Green';
      document.getElementById('message').innerHTML = 'Password is Matched';
    } else {
      document.getElementById('message').style.color = 'Red';
      document.getElementById('message').innerHTML = 'Password is Not Matched';
    }



  }

  getAllData() {
    try {
      this.cmsService.getAllLoginPageData().subscribe((data) => {
        this.allData$ = data;
        //this.activatedRoute.snapshot.data.homeData;
        /*this.navigation = this.allData$.navigation;*/
        this.loginLanding = this.allData$.loginLanding;
        //this.deals = this.allData$.deals;
        //this.footerContacts = this.allData$.footerContacts;
        //this.footerSitemap = this.allData$.footerSitemap;
        //this.footerSocial = this.allData$.footerSocial;
        this.logo = this.allData$.logo[0].logo;
        //this.logo = this.homeLogo.logo;
        this.contentHome = true;
        //this.filtersLoaded = Promise.resolve(true);
      });
    } catch (e) { }
  }

  //verifyOTP() {
  //  try {
  //    this.userService.verifyOTP(this.twilioVerifyObj).subscribe((data) => {
  //      //console.log("Verify Response: " + data);
  //      if (data === "approved") {    
  //        this.router.navigateByUrl('/beneficiary-account');
  //        $(".code_sect").hide();
  //      }
  //      else {
  //        $("#response-screen").show();
  //        document.getElementById("response-screen").innerHTML = "Invalid OTP, Please try again..!"
  //        $("#response-screen").delay(7000).hide(1000);
  //        $(".code_sect").hide();
  //        $(".otp_sect").show();
  //      }
  //    });
  //  } catch (e) { //console.log(e); }
  //}

  toCapitalLettersForAgency(str, e) {
    console.log(str);
    if (str == undefined && str == null && str == "") {
      return
    }
    var event = e.target.id;

    var agencyid = document.getElementById("agencyid") as HTMLInputElement;
    var newagencyid = agencyid.id;


    if (event == newagencyid) {
      var capitalizeticketpnr = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
        }

      );
      this.loginCred.agencyId = capitalizeticketpnr;
    }

  }

  verifyEmailOTP() {
    try {

      this.cmsService.emailOTPVerify(this.loginCred).subscribe((data) => {
        ////console.log("Verify Response: " + data);
        if (data == true) {
          this.authservice.login();
          localStorage.setItem("ParentHierarchy", this.loginCred.parentHierarchy);
          localStorage.setItem("UserId", this.loginCred.userId.toString());
          localStorage.setItem("AgencyId", this.loginCred.agencyId);
          localStorage.setItem("Phone", this.loginCred.mobile);
          localStorage.setItem("fullName", this.loginCred.fullName);
          localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
          localStorage.setItem("UserActive", String(this.loginCred.userActive))
          localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);
          localStorage.setItem("BackSystemCompanyId", this.loginCred.backSystemCompanyId.toString());
          localStorage.setItem("BackSystemCompanyCustomer", this.loginCred.backSystemCompanyCustomer);
           //20-jan24
          localStorage.setItem("AgencyCurrency", this.loginCred.agencyCurrency);
          //end
          this.agencyService.GetUserRoleName(this.loginCred.userId).subscribe(roleName => {

              console.log("LoginUserRoleName Name: ", roleName);
              // set in local storage AFTER receiving
              localStorage.setItem("LoginUserRoleName", roleName);

            });
          // var checkactive = localStorage.getItem("UserActive");
          $(".code_sect").hide();
          this.router.navigateByUrl('/flightSearch');






          //   localStorage.setItem("UserId", this.loginCred.userId.toString());
          //   localStorage.setItem("AgencyId", this.loginCred.agencyId);
          //   localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
          // //  localStorage.setItem("UserActive", this.loginCred.userActive)
          //   localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);
          //   var checkactive = localStorage.getItem("UserActive");

          //   // console.log("Shoib" + checkactive);
          //   if (checkactive == "False") {

          //     $(".code_sect").hide();
          //     $(".form__heading").hide();

          //     $(".new_sect").show();
          //     $(".form__headings").show();

          //   }
          //   else {
          //     this.router.navigateByUrl('/flightSearch');
          //   }
          //   $(".code_sect").hide();
        }

        else {
          // $(".code_sect").show();
          // this.varificationPrompt = this.wrongOTPPrompt;
          //$(".otp_sect").show();
          document.getElementById("response-screenOTP").innerHTML = "Invalid OTP, Please try again..!"
          setTimeout(() => {
            document.getElementById("response-screenOTP").innerHTML = "";
          }, 3000);

        }
      });
    } catch (e) { }
  }

  spinner: boolean = false;
  //22-nov-23
  userLogin() {

    try {
      this.spinner = true;
      this.cmsService.userLoginEmail(this.loginCred).subscribe((data) => {
        if (data.isAuthorized == true) {
          this.loginCred = data;
          this.spinner = false;
          if (data.userActive == false) {
            this.loginCred.otp = "";
            $(".code_sect").hide();
            $(".form__headingCode").hide();
            $(".form__heading").show();
            this.loginCred.password = "";
            $(".new_sect").show();
            $(".login_main_form").hide();
            $(".form__headings").hide();

          }
          else {
            this.loginCred.otp = "";
            $(".code_sect").show();
            $(".form__headingCode").show();
            $(".form__heading").hide();
            this.loginCred.password = "";
            $(".new_sect").hide();
            $(".login_main_form").hide();
            $(".form__headings").hide();

          }
          //this.twilioObj.to = data.mobile;
          // this.authservice.login();
          // this.emailTo = data.email;


          // localStorage.setItem("ParentHierarchy", this.loginCred.parentHierarchy);
          // localStorage.setItem("UserId", this.loginCred.userId.toString());
          // localStorage.setItem("AgencyId", this.loginCred.agencyId);
          // localStorage.setItem("Phone", this.loginCred.mobile);
          // localStorage.setItem("fullName", this.loginCred.fullName);
          // localStorage.setItem("ParentAgency", this.loginCred.parentAgency);
          // localStorage.setItem("UserActive", String(this.loginCred.userActive))
          // localStorage.setItem("ImmediateParent", this.loginCred.immediateParent);

          // localStorage.setItem("BackSystemCompanyId", this.loginCred.backSystemCompanyId.toString());
          // localStorage.setItem("BackSystemCompanyCustomer", this.loginCred.backSystemCompanyCustomer);

          // var checkactive = localStorage.getItem("UserActive");

          // console.log("Shoib" + checkactive);
          // if (checkactive == "False") {

          //   $(".code_sect").hide();
          //   $(".form__heading").show();
          //   this.loginCred.password = "";
          //   $(".new_sect").show();
          //   $(".login_main_form").hide();
          //   $(".form__headings").hide();

          // }
          // else {
          //   this.router.navigateByUrl('/flightSearch');
          // }



          //$(".login_main_form").hide();
          //$(".code_sect").show(); $(".new_sect").hide();
          //$(".form__headings").hide();
          //$(".title_sect").hide();

          //this.varificationPrompt = this.otpPrompt;
          //this.userService.sendOTP(this.twilioObj).subscribe((data) => {
          //  this.twilioVerifyObj.to = data;
          //});
          //this.cmsService.emailOTP(this.emailTo).subscribe((data) => {
          //  if (data.success == true) {
          //    //this.loginEmailVerifyObj.email = data.email;
          //  }
          //})

        }
        else {
          this.spinner = false;
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Incorrect Credentials, Please try again!"
          $("#response-screen").delay(7000).hide(1000);
        }
      });
    }
    catch (e) {
      //console.log(e);
    }
  }
  //end



  //sendOTP() {
  //  //console.log("Resend To: " + this.twilioObj.to);
  //  try {
  //    this.userService.sendOTP(this.twilioObj).subscribe((data) => {
  //      this.twilioVerifyObj.to = data;
  //    });
  //  } catch (e) { //console.log(e); }
  //}
  resendEmailOTP() {
    this.cmsService.emailOTP(this.emailTo).subscribe((data) => {
      if (data.success == true) {
        this.loginCred.email = data.email;
      }
    })
  }

  validatePassword() {
    var st = document.getElementById('password') as HTMLInputElement;
    var stu = document.getElementById('confirm_password') as HTMLInputElement;
    if (st.value != stu.value) {
      document.getElementById('message').style.color = 'red';
      document.getElementById('message').innerHTML = 'Password is not Matched';
      this.valid = false;

    } else {
      this.valid = true;
      document.getElementById('message').innerHTML = '';
    }
    return this.valid;
  }

  UpdateNewUserPassword() {
    if (this.validatePassword() == false) {
      return;
    };
    try {
      /*      console.log(this.loginCred);*/
      var checkv = localStorage.getItem("UserId");
      console.log("userid" + checkv);

      this.cmsService.UpdateNewUserPassword(this.loginCred).subscribe((data) => {
        if (data == true) {

          this.router.navigateByUrl('/flightSearch');
        }
      });
    }
    catch (e) {
      console.log(e);
    }

  }

  //22-nov-23
  ShowOTPSection() {
    $(".code_sect").show();
    $(".form__headingCode").show();
    $(".form__heading").hide();
    this.loginCred.password = "";
    $(".new_sect").hide();
    $(".login_main_form").hide();
    $(".form__headings").hide();

  }
  //end
}
